// This is to ensure that directly referenced theme/color names throughout the core use the
// CSS variable syntax to utilize the color theme mechanism provided by `@swa-ui/theme` without
// bringing it in as a dependency and using its helpers via context. Once all references to direct
// colors are replaced with hex value strings throughout all applications, this helper will be removed.
export const getColorVariable = (colorName) => {
  let colorVariable;

  if (typeof colorName === "string" && colorName.length > 0) {
    if (!colorName.startsWith("var(--") && !colorName.startsWith("#")) {
      colorVariable = `var(--${colorName}, ${colorName})`;
    } else {
      colorVariable = colorName;
    }
  }

  return colorVariable;
};
